import * as angular from "angular";

export class ToggleController {
    name: string;
    large: string;
    value: boolean;
    onChange: Function;
    debounce: number;
    noToggleTimer: angular.IPromise<void>;

    /* @ngInject */
    constructor(private $timeout) {}

    click():void {
        if (this.debounce && !this.noToggleTimer) {
            this.debouncedToggle();
        } else if (!this.debounce) {
            this.toggle();
        }
    };

    getStyleClasses(): string {
        let classes = "";
        if (this.large !== void 0) { classes += "toggle--large "; }
        if (this.value) { classes += "toggle--on "; }
        if (this.value && this.large !== void 0) { classes += "toggle--on-large "; }
        return classes;
    }

    private toggle = (): void => {
        this.value = !this.value;
        this.onChange({name: this.name, value: this.value});
    };

    private debouncedToggle(): void {
        this.toggle();
        this.noToggleTimer = this.$timeout(() => {
            this.$timeout.cancel(this.noToggleTimer);
            this.noToggleTimer = void 0;
        }, this.debounce);
    }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/toggle/toggle.controller.ts
 **/